import React, { useState, useContext, useEffect, useRef } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import { DateTime } from "luxon";
import { ConfigurationContext,
         ContentContext } from '../../context';
import ButtonTextCustom from '../../components/elements/ButtonTextCustom';
import LoaderComponent from '../../components/elements/LoaderComponent';
import { IoMdClose } from "react-icons/io";
import { useTranslation } from 'react-i18next';

import { retrieveFileType,
         shortenFileName } from '../../helpers/functions';

import { ArrowCircleUpIcon } from '../../helpers/icons';

const WrapperStyled = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;

    .input_file{
        position: fixed;
        top: -10000px;
    }
    .bt_action{
        padding: 0;
        margin-top: 15px;
        p{
            margin: 0;
        }
        &.is_loading{
            cursor: default;
            p{
                color: ${props => `rgb(${props.pancolors.middle_gray})`};
            }
            :hover{
                .text{
                    text-decoration: none;
                }
            }
        }
    }
    .help{
        font-size: 13px;
        line-height: 18px;
        font-weight: 600;
        color: ${props => `rgb(${props.pancolors.dark_gray})`};
        margin-top: 5px;
    }
    .head{
        display: flex;
        flex-direction: row;
        align-items: center;
        >.icon{
            display: flex;
            margin-right: 5px;
            svg{
                fill: ${props => `rgb(${props.pancolors.black_overwhite})`};
            }
        }
        >.title{
            font-size: 16px;
            line-height: 16px;
            font-weight: 600;
        }
        &.error{
            >.title{
                color: ${props => `rgb(${props.pancolors.red})`};
            }
            >.icon{
                svg{
                    fill: ${props => `rgb(${props.pancolors.red})`};
                }
            }
        }
    }
    .message_error{
        margin-bottom: 10px;
        color: ${props => `rgb(${props.pancolors.red})`};
        font-weight: 600;
        font-size: 14px;
    }
    .box_upload_file{
        display: flex;
        flex-direction: column;
        width: 100%;
        box-sizing: border-box;
        padding: 10px 10px 10px 10px;
        margin-top: 0;
        margin-bottom: 20px;
        border: 1px dashed ${props => `rgb(${props.pancolors.dark_gray})`};
        
        .box_file{
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            position: relative;
            width: 100%;
            .bt_cancel_upload{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                width: 25px;
                margin-left: 7px;
                color: #FFFFFF;
                border: 1px solid ${props => `rgb(${props.pancolors.red})`};
                background-color: ${props => `rgb(${props.pancolors.red})`};
                cursor: pointer;
                :hover{
                    border: 1px solid ${props => `rgb(${props.pancolors.red})`};
                    color: ${props => `rgb(${props.pancolors.red})`};
                    background-color: ${props => `rgb(${props.pancolors.white})`};
                }
            }
            .loader_bar{
                position: relative;
                background-color: ${props => `rgb(${props.pancolors.light_white})`};
                width: calc(100% - 34px);
                .percent{
                    position: absolute;
                    font-size: 14px;
                    line-height: 14px;
                    font-weight: 600;
                    right: 5px;
                    top: 25%;
                }
                .bar{
                    height: 25px;
                    width: 30%;
                    background-color: ${props => `rgb(${props.pancolors.light_gray})`};
                }
            }
        }
    }
`

const UploadMedia = (props) => {

    const { t } = useTranslation();

    const { title = t("texts.Cargar contenido"), 
            limit,
            className,
            actionButtonText = t("texts.+ Agregar (Video/Audio/Imagen/Documento)"),
            required = false,
            haveError = false,
            setIsLoadingMedia = null,
            scope,
            lang,
            contentByLang, 
            setContentByLang  } = props;

    const { panColors } = useContext(ConfigurationContext);

    const { getByPassImageUploadRoute, basicData } = useContext(ContentContext);

    const [ loadingMediaFile, setLoadingMediaFile ] = useState(false);
    const [ gettingUploadUrl, setGettingUploadUrl ] = useState(false);
    const [ percent, setPercent ] = useState(null);
    const [ fileErrorMessage, setFileErrorMessage ] = useState(null);
    const [ applicationCount, setApplicationCount ] = useState(0);
    const [ showUploadButton, setShowUploadButton ] = useState(false);
    
    let abortControllerRef = useRef();

    const inputFileRef = useRef();
    
    const handleSelectFile = () => {
        inputFileRef.current.click();
    }

    const subirArchivoAS3 = (imageProfileUploadURL, archivo) => {
        
        return new Promise((resolve, reject) => {

            abortControllerRef.current = new AbortController()

            const reader = new FileReader();
      
          reader.onload = () => {
            const archivoData = reader.result;
            
            var config = {
                headers: {
                    'Content-Type': archivo.type,
                },
                signal: abortControllerRef.current.signal,
                onUploadProgress: function(progressEvent) {
                    setPercent(Math.round( (progressEvent.loaded * 100) / progressEvent.total ));
                }
            };

      
            axios.put(imageProfileUploadURL, archivoData, config)
              .then(() => {
                resolve(imageProfileUploadURL.split('?')[0]);
              })
              .catch((error) => {
                reject(error.message);
              });

          };
      
          reader.onerror = (error) => {
            reject(error);
          };
      
          reader.readAsArrayBuffer(archivo);

        });
        

      };


    let size_limit_video = 100;
    let size_limit_audio = 15;
    let size_limit_archives = 30;
    let size_limit_images = 10;

    const handleRawFile = (e) => {
        
        if(scope !== "categories"){
            if(contentByLang[lang].medias.length >= limit){
                setFileErrorMessage(t("texts.Se alcanzo el maximo de archivos permitido"));
                hideMessage();
                return null;
            }
        }
        
        if(e.target.files.length){
            
            const file = e.target.files[0];
            
            //const size_limit_video = 75;
            //const size_limit_audio = 15;
            //const size_limit_archives = 30;
            //const size_limit_images = 10;

            let content_type = '';
            let message = '';
            let isValid = true;
            const file_type = file.type.split("/");
            const name = file.name;
            const extension = name.split('.').pop();
            const mime_type = file_type[0];
            const mime_extension = file_type[1];
            const size = ((file.size / 1024) / 1024);
            
            if(mime_type === "application" && applicationCount >= 1 && scope !== "product_downloads"){
                setFileErrorMessage(t("texts.Se alcanzo el maximo de archivos permitido"));
                hideMessage();
                return null;
            }

            setLoadingMediaFile(true);
            
            switch (mime_type) {
                case "audio":
                    if(scope === "categories" || scope === "products"){
                        isValid = false;
                        message = t("texts.El archivo que intenta agregar no esta permitido");
                    }else{
                        content_type = "Podcast";
                        if(size < size_limit_audio){
                            if(extension !== "mp3"){
                                isValid = false;
                                message = t("texts.El formato permitido es mp3");
                            }
                        }else{
                            isValid = false;
                            message = t("El peso máximo permitido es de megabytes", {size: size_limit_audio})
                        }
                    }
                    break;
                case "application":
                    if(scope === "posts" || scope === "categories" || scope === "products"){
                        isValid = false;
                        message = t("texts.El archivo que intenta agregar no esta permitido");
                    }else{
                        content_type = "Archives";
                        if(size > size_limit_archives){
                            isValid = false;
                            message = t("El peso máximo permitido es de megabytes", {size: size_limit_archives});
                        }else{
                            if(mime_extension !== "vnd.ms-powerpoint" && mime_extension !== "vnd.openxmlformats-officedocument.presentationml.presentation" && mime_extension !== "vnd.ms-excel" && mime_extension !== "vnd.openxmlformats-officedocument.spreadsheetml.sheet" && mime_extension !== "msword" && mime_extension !== "vnd.openxmlformats-officedocument.wordprocessingml.document" && mime_extension !== "pdf"){
                                if(scope === "product_downloads"){
                                    if(mime_extension !== "zip"){
                                        isValid = false;
                                        message = t("texts.Los formatos permitidos son pdf, xlx, xlxs, doc, docx, ppt, pptx, zip");
                                    }
                                }else{
                                    isValid = false;
                                    message = t("texts.Los formatos permitidos son pdf, xlx, xlxs, doc, docx, ppt, pptx");
                                }
                                
                            }
                        }
                    }
                    break;
                case "image":
                    content_type = "Image";
                    if(size < size_limit_images){
                        if(mime_extension !== "jpg" && mime_extension !== "jpeg" && mime_extension !== "png"){
                            isValid = false;
                            message = t("texts.Los formatos soportados permitidos son jpg/jpeg/png");
                        }
                    }else{
                        isValid = false;
                        message = t("El peso máximo permitido es de megabytes", {size: size_limit_images})
                    }
                    break;
                case "video":
                    if(scope === "categories" || scope === "products"){
                        isValid = false;
                        message = t("texts.El archivo que intenta agregar no esta permitido");
                    }else{
                        content_type = "Video";
                        if(size < size_limit_video){
                            if(mime_extension !== "mp4" && mime_extension !== "avi"){
                                isValid = false;
                                message = t("texts.Los formatos soportados permitidos son mp4, avi");
                            }
                        }else{
                            isValid = false;
                            message = t("El peso máximo permitido es de megabytes", {size: size_limit_video});
                        }
                    }
                    break;
                default:
                    isValid = false;
                    message = t("texts.El archivo que intenta agregar no esta permitido");
                    break;
            }

            if(isValid){
                const datetime = DateTime.fromMillis(Date.now());
                setFileErrorMessage("");
                const filename = datetime+"."+extension;
                const payload = { name: filename,
                                  path: "courses/" };
                
                setGettingUploadUrl(true);
                const uploadRoute = getByPassImageUploadRoute(payload, "image/jpeg");
                uploadRoute.then((res) => {
                    setGettingUploadUrl(false);
                    setPercent(0);
                    subirArchivoAS3(res, file)
                    .then((mensaje) => {
                        setPercent(null);
                        if(scope !== "categories"){
                            const slide = {id: `item${contentByLang[lang].medias.length+1}`, 
                                        name: `Item ${contentByLang[lang].medias.length+1}`, 
                                        media_type: content_type, 
                                        media_url: mensaje,
                                        media_name: name.length > 40 ? shortenFileName(name, 15) : name};
                            
                            let contentByLangUpdate = {...contentByLang};
                            contentByLangUpdate[lang].medias.push(slide);
                            setContentByLang(contentByLangUpdate);
                        }
                        if(scope === "categories"){
                            
                            const slide = {id: `item1`, 
                                        name: `Item1`, 
                                        media_type: content_type, 
                                        media_url: mensaje,
                                        media_name: name.length > 40 ? shortenFileName(name, 15) : name};
                            
                            let updateData = {...contentByLang};
                            updateData.translations[lang].image_big = slide;
                            updateData.translations[lang].medias = [slide];
                            setContentByLang(updateData);
                        }
                        
                        setLoadingMediaFile(false);
                        inputFileRef.current.value = '';

                        if(content_type === "Archives"){
                            setApplicationCount(1);
                        }
                    })
                    .catch((error) => {
                        inputFileRef.current.value = '';
                        setLoadingMediaFile(false);
                        setPercent(null);
                    });
                })
                
            }else{
                setLoadingMediaFile(false);
                setFileErrorMessage(message);
                hideMessage();
            }

            return null;
        }
    }

    const handleCancel = () => {
        abortControllerRef.current.abort();
    }

    const hideMessage = () => {

        setTimeout(() => {
            setFileErrorMessage("");
        }, 4000);

    }
    
    useEffect(() => {
        if(setIsLoadingMedia){
            setIsLoadingMedia(loadingMediaFile);
        }
      return () => {}
    }, [loadingMediaFile])
    
    useEffect(() => {
        if(Object.keys(contentByLang).length && scope !== "categories"){
            if(contentByLang[lang].medias){
                contentByLang[lang].medias.map((media, index) => {
                    retrieveFileType(media.media_name);
                })
                
            }
            if(contentByLang[lang]?.medias?.length < limit){
                setShowUploadButton(true);
            }else{
                setShowUploadButton(false);
            }
            
        }
        if(Object.keys(contentByLang).length && scope === "categories"){
            if("medias" in contentByLang.translations[lang]){
                if(!Object.keys(contentByLang.translations[lang].medias).length){
                    setShowUploadButton(true);
                }else{
                    setShowUploadButton(false);
                }
            }else{
                setShowUploadButton(true);
            }
        }
        
      return () => {}
    }, [contentByLang])
    
    if(!basicData){
        return null;
    }
    return (
        <WrapperStyled
            className={className}
            pancolors={panColors}
        >
            
            <input className='input_file' type="file" ref={inputFileRef} onChange={handleRawFile}/>

            <div className={`head ${haveError ? " error" : ""}`}>
                <div className="icon">
                    { <ArrowCircleUpIcon /> }
                </div>
                <div className="title">
                    {title} {required ? "*" : ""}
                </div>
            </div>

            {showUploadButton ? 
            <ButtonTextCustom 
                className={`bt_action${loadingMediaFile ? " is_loading" : ""}`}
                text={actionButtonText}
                onClick={() => { !loadingMediaFile && handleSelectFile()} }

                icon={null}
                background={{ normal: "", hover: "" }}
                border={{ normal: "", hover: "" }}
                textcolor={{ normal: panColors.primary, hover: panColors.primary }}
            /> : ""}

            {fileErrorMessage ?
                <div className='message_error'>{fileErrorMessage}</div>
                : ""
            }

            {loadingMediaFile ? 
                <div className='box_upload_file'>
                    {gettingUploadUrl ?
                        <LoaderComponent size={25} color={panColors.primary} />
                    : ""}
                    {percent !== null ?
                    <div className='box_file'>
                        <div className='loader_bar'>
                            <div className='percent'>{`${percent}%`}</div>
                            <div className='bar' style={{width:`${percent}%`}}></div>
                        </div>
                        <div className='bt_cancel_upload' onClick={handleCancel}>
                            <IoMdClose />
                        </div>
                    </div>
                    : "" }
                </div>
            : ""}

            {scope === "categories" &&
                <div className="help">
                    - {t("texts.Hasta", {size: "1MB"})}<br/>
                    - {t("texts.Formato PNG o JPG")}
                </div>
            }

            {scope === "products" &&
                <div className="help">
                    - {t("texts.Hasta", {size: "1MB"})}<br/>
                    - {t("texts.Formato PNG o JPG")}
                </div>
            }

            {scope === "posts" && 
                <div className="help">
                    - {t("texts.Hasta x archivos", {size: limit})}<br/><br/>
                    - {t("texts.limite_video", {size: size_limit_video+"MB"})}<br/>
                    - {t("texts.limite_imagen", {size: "10MB"})}<br/>
                    - {t("texts.limite_audio", {size: "15MB"})}
                </div>
            }

            {scope === "product_downloads" &&
                <div className="help">
                    - {t("texts.limite_video", {size: size_limit_video+"MB"})}<br/>
                    - {t("texts.limite_imagen", {size: "10MB"})}<br/>
                    - {t("texts.Archivos hasta", {size: "30MB"})}<br/>
                    - {t("texts.Audios hasta", {size: "15MB"})}
                </div>
            }

            {scope !== "posts" && scope !== "products" && scope !== "categories" && scope !== "product_downloads" &&
                <div className="help">
                    - {t("texts.Hasta x archivos", {size: "7"})}<br/><br/>
                    - {t("texts.limite_video", {size: size_limit_video+"MB"})}<br/>
                    - {t("texts.limite_imagen", {size: "10MB"})}<br/>
                    - {t("texts.Archivos hasta", {size: "30MB"})}<br/>
                    - {t("texts.Audios hasta", {size: "15MB"})}
                </div>
            }

        </WrapperStyled>

    )

}

export default UploadMedia;